import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { SubscriptionBaseComponent } from '@components/subscription-base/subscription-base.component';
import { UiService } from '@services/ui.service';
import { Mapping } from '@classes/mapping/mapping';

@Component({
    selector: 'app-structure-edit',
    templateUrl: './structure-edit.component.html',
    styleUrls: ['./structure-edit.component.scss']
})
export class StructureEditComponent extends SubscriptionBaseComponent implements OnInit {
    @Input() structure: Mapping;
    @Output() editFinished = new EventEmitter<Mapping>();

    structForm: UntypedFormGroup;

    isLoading = false;

    constructor(
        private fb: UntypedFormBuilder,
        private uiSrv: UiService
    ) {
        super();
    }

    ngOnInit() {
        this.initForm();
        this.initSubscriptions();
    }

    onSubmit(): void {
        this.isLoading = true;
        if (this.structure) {
            this.update();
        } else {
            this.create();
        }
    }

    onCancel(): void {
        this.editFinished.emit(null);
    }

    private update(): void {
        const newStructure: Mapping = this.objectFromForm();
        this.structure.label = newStructure.label;
        this.structure.description = newStructure.description;
        this.structure.isDefault = newStructure.isDefault;

        this.editFinished.emit(this.structure);
    }

    private create(): void {
        const structure: Mapping = this.objectFromForm();
        this.editFinished.emit(structure);
    }

    private objectFromForm(): Mapping {
        return new Mapping(
            this.structForm.value.label,
            this.structForm.value.description,
            this.structForm.value.isDefault
        );
    }

    private initSubscriptions(): void {
        this.subscription.add(
            this.uiSrv.isLoadingSubject
            .subscribe(loadingState => {
                this.isLoading = loadingState;
            })
        );
    }

    private initForm(): void {
        let label = '';
        let description = '';
        let isDefault = false;

        if(this.structure) {
            label = this.structure.label;
            description = this.structure.description;
            isDefault = this.structure.isDefault;
        }

        this.structForm = this.fb.group({
            label: [label, [Validators.required]],
            description: [description],
            isDefault: [isDefault]
        });
    }
}
